import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { getUpcomingEvents } from "../../shared/helpers";
import EventCard from "./EventCard";
import { useData } from "../../providers/dataProvider";

export default function EventsSection() {
  const { events } = useData();
  const closestEvents = getUpcomingEvents(events, 3);

  if (events.length === 0) {
    return null;
  }

  return (
    <Container className="py-5">
      <Row className="g-4 justify-content-center">
        <h2 className="text-center">Upcoming Events</h2>
        {closestEvents.map((event, index) => (
          <Col
            key={index}
            xs={12}
            md={6}
            lg={4}
            className="d-flex justify-content-center"
          >
            <EventCard event={event} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}
